import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ModalConfig {
    show: boolean;
    title: string;
    message: string;
    type: 'error' | 'warning' | 'success';
    onClose?: () => void;
}

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private _modalConfig = new BehaviorSubject<ModalConfig>({
        show: false,
        title: '',
        message: '',
        type: 'error'
    });

    get modalConfig$(): Observable<ModalConfig> {
        return this._modalConfig.asObservable();
    }

    /**
     * Show an error modal
     * @param title
     * @param message The error message to display
     * @param onClose Optional callback to execute when the modal is closed
     */
    showError(title: string, message: string, onClose?: () => void): void {
        this._modalConfig.next({
            show: true,
            title,
            message: message || 'A server error occurred.',
            type: 'error',
            onClose
        });
    }

    /**
     * Show a warning modal
     * @param message The warning message to display
     * @param onClose Optional callback to execute when the modal is closed
     */
    showWarning(message: string, onClose?: () => void): void {
        this._modalConfig.next({
            show: true,
            title: 'Warning!',
            message,
            type: 'warning',
            onClose
        });
    }

    /**
     * Show a success modal
     * @param message The success message to display
     * @param onClose Optional callback to execute when the modal is closed
     */
    showSuccess(message: string, onClose?: () => void): void {
        this._modalConfig.next({
            show: true,
            title: 'Success!',
            message,
            type: 'success',
            onClose
        });
    }

    /**
     * Hide the modal
     */
    hide(): void {
        this._modalConfig.next({
            show: false,
            title: '',
            message: '',
            type: 'error'
        });
    }
}

